var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5469 2.68924L14.5067 2.65936C13.4008 1.83267 12.5261 1.18526 11.7822 0.747012C11.0181 0.288845 10.3043 0 9.53016 0C8.74598 0 8.03218 0.288845 7.27816 0.737052C6.53419 1.1753 5.65953 1.82271 4.55364 2.63944L4.51342 2.65936C2.55297 4.10359 1.21585 5.0996 0.552309 6.57371C-0.121282 8.03785 -0.0810673 9.86056 0.160219 12.8088C0.351237 15.0896 0.874023 16.992 2.40217 18.257C3.90015 19.502 6.19237 20 9.5 20C12.8076 20 15.0898 19.492 16.5978 18.247C18.1159 16.9721 18.6488 15.0797 18.8398 12.7888C19.0811 9.84064 19.1213 8.00797 18.4477 6.54382C17.7741 5.06972 16.437 4.07371 14.4866 2.61952L14.5469 2.68924ZM5.71985 14.2829C5.71985 13.8347 6.07173 13.4861 6.52414 13.4861H12.5563C12.9986 13.4861 13.3606 13.8347 13.3606 14.2829C13.3606 14.7211 12.9986 15.0797 12.5563 15.0797H6.52414C6.07173 15.0797 5.71985 14.7211 5.71985 14.2829Z",
    fill: "#484888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreIcon);
export default __webpack_public_path__ + "static/media/explore-icon.bf01f337a4e53d61ba3ce4c5be76bd04.svg";
export { ForwardRef as ReactComponent };